import * as PropTypes from 'prop-types';

export const WidgetShape = PropTypes.shape({
  type: PropTypes.string,
  size: PropTypes.number,
  position: PropTypes.number,
});

export const DashboardShape = PropTypes.shape({
  uuid: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  is_public: PropTypes.bool,
  widgets: PropTypes.arrayOf(WidgetShape),
});
